// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetIndexAdvisorIssuesQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  state?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type GetIndexAdvisorIssuesQuery = {
  __typename?: "GraphqlQuery";
  getIssues: Array<{
    __typename?: "Issue";
    id: string;
    databaseId?: string | null;
    checkGroupAndName: string;
    description: string;
    descriptionTemplate: string;
    details: any;
    groupingKey: any;
    descriptionReferences: Array<{
      __typename?: "IssueDescriptionReference";
      param: string;
      name: string;
      path?: string | null;
    }>;
    references: Array<{
      __typename?: "IssueReference";
      referentId: string;
      kind: string;
    }>;
  }>;
  getIssueCounts: Array<{
    __typename?: "IssueSummary";
    id: string;
    checkGroupAndName: string;
    newCount: number;
    resolvedCount: number;
  }>;
  indexingEngineConfig: {
    __typename?: "CheckConfig";
    id: string;
    enabled: boolean;
  };
  indexUnusedConfig: {
    __typename?: "CheckConfig";
    id: string;
    enabled: boolean;
  };
  getDatabaseDetails: {
    __typename?: "Database";
    id: string;
    totalIndexSize: number;
    hasColumnStats: boolean;
    hasInitialIndexAdvisorAnalysis: boolean;
    indexWriteOverhead: {
      __typename?: "DatabaseIndexWriteOverhead";
      tableWritesPerMinute?: number | null;
      totalWriteOverhead?: number | null;
      tablesWithMissingStats: number;
      tablesWithMissingIndexMetadata: number;
      tablesWithDefaultExprIndexOverhead: number;
      updatedAt?: number | null;
    };
  };
  getSchemaTables: Array<{
    __typename?: "SchemaTable";
    id: string;
    tableName: string;
    schemaName: string;
    lastStats?: {
      __typename?: "SchemaTableInlineStats";
      dataSizeBytes?: number | null;
      indexSizeBytes?: number | null;
    } | null;
    stats7dAgo?: {
      __typename?: "SchemaTableInlineStats";
      dataSizeBytes?: number | null;
      indexSizeBytes?: number | null;
    } | null;
  }>;
};

export const GetIndexAdvisorIssuesDocument = gql`
  query GetIndexAdvisorIssues($databaseId: ID!, $state: String) {
    getIssues(
      databaseId: $databaseId
      checkGroupsAndNames: [
        "index_advisor/indexing_engine"
        "schema/index_unused"
      ]
      state: $state
    ) {
      id
      databaseId
      checkGroupAndName
      description
      descriptionTemplate
      descriptionReferences {
        param
        name
        path
      }
      details
      references {
        referentId
        kind
      }
      groupingKey
    }
    getIssueCounts(
      databaseId: $databaseId
      checkGroupsAndNames: [
        "index_advisor/indexing_engine"
        "schema/index_unused"
      ]
    ) {
      id
      checkGroupAndName
      newCount
      resolvedCount
    }
    indexingEngineConfig: getCheckConfig(
      databaseId: $databaseId
      checkGroupAndName: "index_advisor/indexing_engine"
    ) {
      id
      enabled
    }
    indexUnusedConfig: getCheckConfig(
      databaseId: $databaseId
      checkGroupAndName: "schema/index_unused"
    ) {
      id
      enabled
    }
    getDatabaseDetails(databaseId: $databaseId) {
      id
      totalIndexSize
      indexWriteOverhead {
        tableWritesPerMinute
        totalWriteOverhead
        tablesWithMissingStats
        tablesWithMissingIndexMetadata
        tablesWithDefaultExprIndexOverhead
        updatedAt
      }
      hasColumnStats
      hasInitialIndexAdvisorAnalysis
    }
    getSchemaTables(databaseId: $databaseId) {
      id
      tableName
      schemaName
      lastStats {
        dataSizeBytes
        indexSizeBytes
      }
      stats7dAgo {
        dataSizeBytes
        indexSizeBytes
      }
    }
  }
`;

/**
 * __useGetIndexAdvisorIssuesQuery__
 *
 * To run a query within a React component, call `useGetIndexAdvisorIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndexAdvisorIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndexAdvisorIssuesQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetIndexAdvisorIssuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndexAdvisorIssuesQuery,
    GetIndexAdvisorIssuesQueryVariables
  > &
    (
      | { variables: GetIndexAdvisorIssuesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndexAdvisorIssuesQuery,
    GetIndexAdvisorIssuesQueryVariables
  >(GetIndexAdvisorIssuesDocument, options);
}
export function useGetIndexAdvisorIssuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndexAdvisorIssuesQuery,
    GetIndexAdvisorIssuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndexAdvisorIssuesQuery,
    GetIndexAdvisorIssuesQueryVariables
  >(GetIndexAdvisorIssuesDocument, options);
}
// @ts-ignore
export function useGetIndexAdvisorIssuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIndexAdvisorIssuesQuery,
    GetIndexAdvisorIssuesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorIssuesQuery,
  GetIndexAdvisorIssuesQueryVariables
>;
export function useGetIndexAdvisorIssuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorIssuesQuery,
        GetIndexAdvisorIssuesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorIssuesQuery | undefined,
  GetIndexAdvisorIssuesQueryVariables
>;
export function useGetIndexAdvisorIssuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorIssuesQuery,
        GetIndexAdvisorIssuesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIndexAdvisorIssuesQuery,
    GetIndexAdvisorIssuesQueryVariables
  >(GetIndexAdvisorIssuesDocument, options);
}
export type GetIndexAdvisorIssuesQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorIssuesQuery
>;
export type GetIndexAdvisorIssuesLazyQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorIssuesLazyQuery
>;
export type GetIndexAdvisorIssuesSuspenseQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorIssuesSuspenseQuery
>;
export type GetIndexAdvisorIssuesQueryResult = Apollo.QueryResult<
  GetIndexAdvisorIssuesQuery,
  GetIndexAdvisorIssuesQueryVariables
>;
